<div class="_wf-pb-formelement">
  <label>Select Template</label>
  @if (currentData.templatedatasource) {
    <kx-multiselect-dropdown class="flex-grow-1"
      [placeholder]="'Select templates'" [questions]="currentData.templatequestion"
      [settings]="currentData.templatedefaultsetting" [data]="currentData.templatedatasource"
      [(ngModel)]="currentData.selectedTemplate" (onDeSelect)="onTemplateItemDeselect($event);"
      (onSelect)="onTemplateItemSelect($event)">
    </kx-multiselect-dropdown>
  }
</div>
@if (_currentData.dataList != null && _currentData.showView && _currentData.currentListComputedFields) {
  <div id="ui_{{_currentData.resource}}">
    @if (_currentData.currentAction === 'LIST') {
      <dhs-data-grid [fields]="_currentData.currentListComputedFields"
        [cardHeaders]="_currentData.cardHeader" [filterFieldGroup]="_currentData.currentFilterListFormFields"
        [data]="_currentData.dataList" [bulkActionsConfig]="_currentData.bulkAction" [rowClick]="_currentData.rowClick"
        (configValues)="getConfigValues($event)" (bulkActionClicked)="onBulkActionClicked($event)"
        (bindGrid)="bindDataToGrid($event)" (onLimitChange)="limitChanged($event)"
        (onFilterChange)="filterChange($event)" (editEllipseClick)="buttonAction($event)"
        (onPageChanges)="pageChanges($event)" (onSortChanges)="sortChanges($event);"
        [config]="_currentData.dataGridConfig">
      </dhs-data-grid>
    }
  </div>
}